<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer008" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_1#_idTextAnchor001">Chapter 1</a></p>
<p class="TOCitem"><a href="#/Chapter_2#_idTextAnchor002">Chapter 2</a></p>
<p class="TOCitem"><span href="#/Chapter_3#_idTextAnchor003" title="Link target outside of Sample">Chapter 3</span></p>
<p class="TOCitem"><span href="#/Chapter_4#_idTextAnchor004" title="Link target outside of Sample">Chapter 4</span></p>
<p class="TOCitem"><span href="#/Chapter_5#_idTextAnchor005" title="Link target outside of Sample">Chapter 5</span></p>
<p class="TOCitem"><span href="#/Chapter_6#_idTextAnchor006" title="Link target outside of Sample">Chapter 6</span></p>
<p class="TOCitem"><span href="#/Chapter_7#_idTextAnchor007" title="Link target outside of Sample">Chapter 7</span></p>
<p class="TOCitem"><span href="#/Chapter_8#_idTextAnchor008" title="Link target outside of Sample">Chapter 8</span></p>
<p class="TOCitem"><span href="#/Chapter_9#_idTextAnchor009" title="Link target outside of Sample">Chapter 9</span></p>
<p class="TOCitem"><span href="#/Chapter_10#_idTextAnchor010" title="Link target outside of Sample">Chapter 10</span></p>
<p class="TOCitem"><span href="#/Chapter_11#_idTextAnchor011" title="Link target outside of Sample">Chapter 11</span></p>
<p class="TOCitem"><span href="#/Chapter_12#_idTextAnchor012" title="Link target outside of Sample">Chapter 12</span></p>
<p class="TOCitem"><span href="#/Chapter_13#_idTextAnchor013" title="Link target outside of Sample">Chapter 13</span></p>
<p class="TOCitem"><span href="#/Epilogue#_idTextAnchor014" title="Link target outside of Sample">Epilogue</span></p>
<p class="TOCitem"><span href="#/Excerpt#_idTextAnchor015" title="Link target outside of Sample">Excerpt from <i>Special Ops Cowboy</i> by Addison Fox</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7647fb45